angular.module('rxrefills').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/rxrefills/views/prescriptions.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-md-3 col-xs-flush\">\r" +
    "\n" +
    "                <div class=\"panel-subheading\">\r" +
    "\n" +
    "                    {{::'My Pharmacy' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"bottom-line col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                    <div ng-if=\"mapDisplay\">\r" +
    "\n" +
    "                        <ap-google-maps\r" +
    "\n" +
    "                                id=\"ap-google-maps\"\r" +
    "\n" +
    "                                name=\"selectedPharmacy.pharmacy.Name\"\r" +
    "\n" +
    "                                address=\"selectedPharmacy.pharmacy.Address.Address1\"\r" +
    "\n" +
    "                                city=\"selectedPharmacy.pharmacy.Address.City\"\r" +
    "\n" +
    "                                state=\"selectedPharmacy.pharmacy.Address.State\"\r" +
    "\n" +
    "                                zip=\"selectedPharmacy.pharmacy.Address.Zip\">\r" +
    "\n" +
    "                        </ap-google-maps>\r" +
    "\n" +
    "                        <h4><b>{{::selectedPharmacy.pharmacy.Name}}</b></h4>\r" +
    "\n" +
    "                        {{::selectedPharmacy.pharmacy.Address.Address1}}\r" +
    "\n" +
    "                        <br>\r" +
    "\n" +
    "                        {{::selectedPharmacy.pharmacy.Address.City}},&nbsp;{{::selectedPharmacy.pharmacy.Address.State}}&nbsp;{{::selectedPharmacy.pharmacy.Address.Zip}}\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"bottom-line col-xs-12\">\r" +
    "\n" +
    "                            p.&nbsp;{{::selectedPharmacy.pharmacy.Phone.PhoneNumber | apPhoneNumberFilter}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12\">\r" +
    "\n" +
    "                            <a ng-click=\"changePharmacy()\">{{::'Change my Pharmacy' | translate}}</a>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-if=\"!mapDisplay\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12\">\r" +
    "\n" +
    "                            <a ng-click=\"changePharmacy()\">{{::'Add a Pharmacy' | translate}}</a>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-md-9 flush-right\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"ap-margin-bottom-30 flush-left flush-right\">\r" +
    "\n" +
    "                    <div class=\"panel-subheading\">\r" +
    "\n" +
    "                        {{::'Current Prescriptions' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-if=\"!currentPrescriptions.length\" class=\"col-xs-12\">\r" +
    "\n" +
    "                        {{::'No Current Prescriptions' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"striped row panel-row\" ng-repeat=\"med in currentPrescriptions track by $index\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-6 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                                {{::med.DrugName}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-12 smaller\">\r" +
    "\n" +
    "                                {{::med.Instructions}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-4 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"row-item col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                <div class=\"col-xs-2 smaller\">\r" +
    "\n" +
    "                                    {{::'Start' | translate}}&nbsp;\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-10\">\r" +
    "\n" +
    "                                    <span ap-date-formatter date=\"{{::med.StartDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row-item col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                <div class=\"col-xs-2 smaller\">\r" +
    "\n" +
    "                                    {{::'End' | translate}}&nbsp;\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-10\">\r" +
    "\n" +
    "                                    <span ap-date-formatter date=\"{{::med.EndDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-2 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"!med.RefillRequestPending && !med.IsDiscontinued && med.ProviderId\">\r" +
    "\n" +
    "                                <button class=\"btn btn-lg-height btn-default1\" ng-click=\"medSelect(med)\"\r" +
    "\n" +
    "                                        data-transition-to=\"{appRoute: 'rxrefill'}\">{{'Request Refill' | translate}}\r" +
    "\n" +
    "                                </button>\r" +
    "\n" +
    "                                <br>\r" +
    "\n" +
    "                                {{::med.IsActive ? dateDiff(med.EndDate) : ''}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"med.IsDiscontinued\">\r" +
    "\n" +
    "                                <div class=\"btn-height flexbox flexbox-horizontal-center\"><span\r" +
    "\n" +
    "                                        class=\"btn-width pending text-center\">{{'Discontinued' | translate}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"med.RefillRequestPending\">\r" +
    "\n" +
    "                                <button class=\"btn btn-lg-height btn-default1 btn-minpadding\" ng-click=\"medSelect(med)\"\r" +
    "\n" +
    "                                        data-transition-to=\"{appRoute: 'rxrefill'}\"><span class=\"lime-green\">{{'Refill Requested' | translate}}</span>\r" +
    "\n" +
    "                                </button>\r" +
    "\n" +
    "                                <div class=\"pending text-center\">{{'Pending Review' | translate}}</div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"!med.ProviderId\">\r" +
    "\n" +
    "                                <div class=\"btn-height flexbox flexbox-horizontal-center\"><span\r" +
    "\n" +
    "                                        class=\"btn-width pending text-center\">{{'Please contact office to process.' | translate}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"panel-subheading\">\r" +
    "\n" +
    "                    {{::'Previous Prescriptions' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                    <div ng-if=\"!previousPrescriptions.length\" class=\"col-xs-12\">\r" +
    "\n" +
    "                        {{::'No Previous Prescriptions' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"striped row panel-row\" ng-repeat=\"med in previousPrescriptions track by $index\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-6 col-xs-flush \">\r" +
    "\n" +
    "                            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                                {{::med.DrugName}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-12 smaller\">\r" +
    "\n" +
    "                                {{::med.Instructions}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-4 col-xs-flush \">\r" +
    "\n" +
    "                            <div class=\"row-item col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                <div class=\"col-xs-2 smaller\">\r" +
    "\n" +
    "                                    {{::'Start' | translate}}&nbsp;\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-10\">\r" +
    "\n" +
    "                                    <span ap-date-formatter date=\"{{::med.StartDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row-item col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                <div class=\"col-xs-2 smaller\">\r" +
    "\n" +
    "                                    {{::'End' | translate}}&nbsp;\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-10\">\r" +
    "\n" +
    "                                    <span ap-date-formatter date=\"{{::med.EndDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-2 col-xs-flush \">\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"!med.RefillRequestPending && !med.IsDiscontinued && med.ProviderId\">\r" +
    "\n" +
    "                                <button class=\"btn btn-lg-height btn-default1\" ng-click=\"medSelect(med)\"\r" +
    "\n" +
    "                                        data-transition-to=\"{appRoute: 'rxrefill'}\">{{'Request Refill' | translate}}\r" +
    "\n" +
    "                                </button>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"med.IsDiscontinued\">\r" +
    "\n" +
    "                                <div class=\"btn-height flexbox flexbox-horizontal-center\"><span\r" +
    "\n" +
    "                                        class=\"btn-width pending text-center\">{{'Discontinued' | translate}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"med.RefillRequestPending\">\r" +
    "\n" +
    "                                <button class=\"btn btn-default1 btn-minpadding\" ng-click=\"medSelect(med)\"\r" +
    "\n" +
    "                                        data-transition-to=\"{appRoute: 'rxrefill'}\"><span class=\"lime-green\">{{'Refill Requested' | translate}}</span>\r" +
    "\n" +
    "                                </button>\r" +
    "\n" +
    "                                <div class=\"pending text-center\">{{'Pending Review' | translate}}</div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"pull-right\" ng-if=\"!med.ProviderId\">\r" +
    "\n" +
    "                                <div class=\"btn-height flexbox flexbox-horizontal-center\"><span\r" +
    "\n" +
    "                                        class=\"btn-width pending text-center\">{{'Please contact office to process.' | translate}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient medications could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s medications.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/rxrefills/views/rxrefills.html',
    "<div ng-cloak class=\"panel panel-default panel-flush panel-body\">\r" +
    "\n" +
    "    <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "        <div class=\"col-xs-12 col-xs-flush col-md-3\">\r" +
    "\n" +
    "            <div class=\"panel-heading panel-flush\">\r" +
    "\n" +
    "                {{::'Selected Pharmacy' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"selectedPharmacy && selectedPharmacy.pharmacy && selectedPharmacy.pharmacy.Name\">\r" +
    "\n" +
    "                <div class=\"body-line col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                        <div ng-if=\"mapDisplay\">\r" +
    "\n" +
    "                            <ap-google-maps\r" +
    "\n" +
    "                                name=\"selectedPharmacy.pharmacy.Name\"\r" +
    "\n" +
    "                                address=\"selectedPharmacy.pharmacy.Address.Address1\"\r" +
    "\n" +
    "                                city=\"selectedPharmacy.pharmacy.Address.City\"\r" +
    "\n" +
    "                                state=\"selectedPharmacy.pharmacy.Address.State\"\r" +
    "\n" +
    "                                zip=\"selectedPharmacy.pharmacy.Address.Zip\">\r" +
    "\n" +
    "                            </ap-google-maps>\r" +
    "\n" +
    "                            <h4><b>{{selectedPharmacy.pharmacy.Name}}</b></h4>\r" +
    "\n" +
    "                                {{selectedPharmacy.pharmacy.Address.Address1}}\r" +
    "\n" +
    "                            <br />\r" +
    "\n" +
    "                                {{selectedPharmacy.pharmacy.Address.City}},&nbsp;{{selectedPharmacy.pharmacy.Address.State}}&nbsp;{{selectedPharmacy.pharmacy.Address.Zip}}\r" +
    "\n" +
    "                            <div class=\"bottom-line col-xs-12\">\r" +
    "\n" +
    "                                    p.&nbsp;{{selectedPharmacy.pharmacy.Phone.PhoneNumber | apPhoneNumberFilter}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                                <a ng-click=\"changePharmacy()\">{{::'Change my Pharmacy' | translate}}</a>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"!mapDisplay\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                                <a ng-click=\"changePharmacy()\">{{::'Add a Pharmacy' | translate}}</a>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"!(selectedPharmacy && selectedPharmacy.pharmacy && selectedPharmacy.pharmacy.Name)\">\r" +
    "\n" +
    "                <p class=\"has-error\">No pharmacy is selected. Please select a pharmacy to continue.</p>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "        <div class=\"col-xs-12 col-md-9 flush-right\">\r" +
    "\n" +
    "            <div class=\"panel-heading panel-flush\">\r" +
    "\n" +
    "                {{::'Request Refills' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div>\r" +
    "\n" +
    "                <div class=\"panel-subheading\">\r" +
    "\n" +
    "                    {{::'Which prescriptions would you like refilled?' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"form-section\">\r" +
    "\n" +
    "                    <div class=\"body-line\">\r" +
    "\n" +
    "                        <div class=\"striped col-xs-12\" ng-repeat=\"med in orderedPrescriptions track by $index\"\r" +
    "\n" +
    "                             ng-if=\"med && !med.IsDiscontinued && med.ProviderId\">\r" +
    "\n" +
    "                            <div class=\"row-item\">\r" +
    "\n" +
    "                                <div class=\"col-xs-2 col-xs-flush col-sm-1\">\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        <input type=\"checkbox\" id=\"{{med.MedicationSIGUid}}\"\r" +
    "\n" +
    "                                        ng-model=\"med.SelectedForRefillRequest\"\r" +
    "\n" +
    "                                        ap-checkbox-hidden-label=\"{{med.DrugName}}\">\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-sm-4\" ng-click=\"medCheck(med)\">\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        {{::med.DrugName}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"smaller\">\r" +
    "\n" +
    "                                        {{::med.Instructions}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-sm-4 col-flush\" ng-click=\"medCheck(med)\">\r" +
    "\n" +
    "                                    <div class=\"row-item col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-2 smaller\">\r" +
    "\n" +
    "                                            {{::'Start' | translate}}&nbsp;\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-10\">\r" +
    "\n" +
    "                                            <span ap-date-formatter date=\"{{::med.StartDate}}\"\r" +
    "\n" +
    "                                                  format=\"long-date\"></span>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"row-item col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-2 smaller\">\r" +
    "\n" +
    "                                            {{::'End' | translate}}&nbsp;\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-10\">\r" +
    "\n" +
    "                                            <span ap-date-formatter date=\"{{::med.EndDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush padding-vert\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush col-sm-3 padding-vert\">\r" +
    "\n" +
    "                            <label ng-class=\"['pull-right', 'padding-vert', (!(selectedPharmacy && selectedPharmacy.pharmacy && selectedPharmacy.pharmacy.Name) ? 'has-error' : '')]\"\r" +
    "\n" +
    "                                for=\"selectPharmacy\">\r" +
    "\n" +
    "                                {{::'Select Pharmacy' | translate}}&nbsp;\r" +
    "\n" +
    "                            </label>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush col-sm-9 padding-vert\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-xs-flush pull-left col-flush\">\r" +
    "\n" +
    "                                <select class=\"pharmacySelection form-control arrow-dropdown\"\r" +
    "\n" +
    "                                        id=\"selectPharmacy\"\r" +
    "\n" +
    "                                        ng-model=\"selectedPharmacy.pharmacy\"\r" +
    "\n" +
    "                                        ng-options=\"pharmacyFormat(pharm) for pharm in patient.Pharmacies\">\r" +
    "\n" +
    "                                </select>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush col-sm-3\">\r" +
    "\n" +
    "                            <label class=\"pull-right\"\r" +
    "\n" +
    "                                    for=\"reason\">\r" +
    "\n" +
    "                                {{::'Refill Reason' | translate}}&nbsp;\r" +
    "\n" +
    "                            </label>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush col-sm-9\">\r" +
    "\n" +
    "                            <textarea id=\"reason\" class=\"col-xs-12 col-xs-flush pull-left\" rows=\"4\" ng-model=\"Reason\"></textarea>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                            <button class=\"btn btn-default2 btn-lg\" id=\"cancelRefillRequest\"\r" +
    "\n" +
    "                                    data-transition-to=\"{appRoute: 'prescriptions'}\">\r" +
    "\n" +
    "                                {{::'Cancel' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                            <button class=\"btn btn-primary btn-lg pull-right\" id=\"refillRequest\" ng-click=\"rxRefillRequest()\" ng-disabled=\"!(selectedPharmacy && selectedPharmacy.pharmacy && selectedPharmacy.pharmacy.Name)\">\r" +
    "\n" +
    "                                <ap-spinner ng-show=\"requestLoading\"></ap-spinner>{{::'Submit Request' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient medications could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s medications.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );

}]);
